// @flow
import React from "react";
import { StyleSheet, View, Text } from "react-native";

type liifeTextType = {
  text: string,
  style: {},
};

const LiifeText = ({ text, style }: liifeTextType) => {
  const textStyle = style
    ? { ...styles.textStyle, ...style }
    : styles.textStyle;

  return <Text style={textStyle}>{text}</Text>;
};

const styles = StyleSheet.create({
  textStyle: {
    marginBottom: 10,
    fontSize: 20,
    color: "#4A4A4A",
    letterSpacing: 0.27,
    fontWeight: "bold",
  },
});

export { LiifeText };
